import { render } from "./TeethExam.vue?vue&type=template&id=1100a5d4&ts=true"
import script from "./TeethExam.vue?vue&type=script&lang=ts"
export * from "./TeethExam.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/kosugi/Dev/IdeaProjects/v4/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__